import { useMemo } from 'react';

interface UsePopoverDataOptions {
  data: any[] | null;
  allDataLoaded: boolean;
  currentSearchValue: string;
  labelItem: string;
  formatLabel?: (value: string) => string;
}

// Client-side filter applied only when all pages are loaded;
// falls back to raw data when server-side paging is still active.
const usePopoverData = ({
  data,
  allDataLoaded,
  currentSearchValue,
  labelItem,
  formatLabel = (label) => label,
}: UsePopoverDataOptions): any[] | null => {
  return useMemo(() => {
    if (!allDataLoaded || currentSearchValue === '' || !data) {
      return data;
    }

    return data.filter((v) =>
      formatLabel(String(v[labelItem]))
        .toLowerCase()
        .includes(currentSearchValue.toLowerCase())
    );
  }, [allDataLoaded, currentSearchValue, data, labelItem, formatLabel]);
};

export default usePopoverData;
